(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.FusionFinancialPartners",
                {
                    url: "/FusionFinancialPartners",
                    component: "fusionFinancialPartners",
                    PageTitle: "Fusion Financial Partners",
                    requiredPermissions: "Dol:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);
    
    app.component("fusionFinancialPartners",
        {
            templateUrl: "App/Resources/FusionFinancialPartners/fusionFinancialPartners.html",
            controller: fusionFinancialPartnersCtrl,
            bindings: {
                states: "<"
            }
        });

    fusionFinancialPartnersCtrl.$inject = ["amplitudeService"];

    function fusionFinancialPartnersCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

    }
})(window.app, window.angular); // jshint ignore:line